export default "__VITE_ASSET__0ypfaE6y__"